export default "__VITE_ASSET__$ife4C2i__"